import { RouterView } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'cfo-panel',
    component: RouterView,
    meta: {
      layoutFeatures: {
        actionPanel: true,
      },
    },
    children: [
      {
        path: '',
        component: () => import('@/app/modules/cfo-panel/views/cfo-panel-index.vue'),
        redirect: '/cfo-panel/money-performance',
        children: [
          {
            path: 'money-performance',
            component: () =>
              import('@/app/modules/cfo-panel/views/cfo-panel-money-performance.vue'),
          },
          {
            path: 'dead-money',
            component: () => import('@/app/modules/cfo-panel/views/cfo-panel-dead-money.vue'),
          },
          {
            path: 'lost-money',
            component: () => import('@/app/modules/cfo-panel/views/cfo-panel-lost-money.vue'),
          },
          {
            path: 'global-performance',
            component: () => import('@/app/modules/cfo-panel/views/cfo-panel-lost-money.vue'),
          },
        ],
      },
    ],
  },
];
export default routes;
